@keyframes logo-animation {
  /* Starting state */
  0% {
    transform: scale(1) rotate(0deg);
    opacity: 0.6;
  }

  /* Reduce size and bump opacity */
  7.5% {
    transform: scale(0.75) rotate(0deg);
    opacity: 0.8;
  }

  /* 20ms delay */
  8% {
    transform: scale(0.75) rotate(0deg);
    opacity: 0.8;
  }

  /* Rotate 180 degree forward while increasing size and reducing opacity */
  25% {
    transform: scale(1) rotate(180deg);
    opacity: 0.6;
  }

  /* 900ms delay */
  47.5% {
    transform: scale(1) rotate(180deg);
    opacity: 0.6;
  }

  /* Reduce size and bump opacity */
  55% {
    transform: scale(0.75) rotate(180deg);
    opacity: 0.8;
  }

  /* 20ms delay */
  55.5% {
    transform: scale(0.75) rotate(180deg);
    opacity: 0.8;
  }

  /* Rotate 180 degree backward while increasing size and reducing opacity */
  70% {
    transform: scale(1) rotate(0deg);
    opacity: 0.6;
  }

  /* 900ms delay */
  100% {
    transform: scale(1) rotate(0deg);
    opacity: 0.6;
  }
}

.weave-loader {
  width: 64px;
  height: 64px;
  opacity: 0.6;
  position: absolute;
  top: calc(50% - 32px);
  left: calc(50% - 32px);
  animation: logo-animation 4s ease-out infinite;
}
